import React from 'react'
import { InputWrapper } from '../style'
import { Form } from "react-bootstrap"

const Index = (props) => {
  const { type, onClick, min, placeholder, onChange, value, disabled, className, width, marginBottom, readOnly, optional, label, height, important, inputRef, defaultValue, onKeyDown, onBlur, autoFocus, endIcon, overlayClassName, as } = props

  return (
    <InputWrapper className={overlayClassName} onClick={onClick} width={width} marginBottom={marginBottom} height={height}>
      <Form.Group>
        {label &&
          <label>
            {label}
            {important && <span>*</span>}
            {optional && <span className="optional-text">(Optional)</span>}
          </label>}
        <span className={className}>
          <Form.Control
            className={className}
            disabled={disabled}
            min={min}
            value={value}
            defaultValue={defaultValue}
            type={type}
            as={as}
            placeholder={placeholder}
            onChange={onChange}
            readOnly={readOnly}
            onKeyDown={onKeyDown}
            autoFocus={autoFocus}
            onBlur={onBlur}
            ref={inputRef}
          />
         <span className='icon-wrapper'>{endIcon}</span>
        </span>
      </Form.Group>
    </InputWrapper>
  )
}

export default Index
